import React from "react"
import { COPY } from "../config/copy"
import { ActionsRow } from "./ActionsRow"

interface NoMatchProps {
  onRestart: () => void
}

export function NoMatch({ onRestart }: NoMatchProps): JSX.Element {
  return (
    <section className="csw-step" aria-live="polite">
      <h2 className="csw-question-title @max-5xl:text-[clamp(30px,8vw,40px)] @max-5xl:font-medium @max-5xl:max-w-none">
        {COPY.noMatch.title}
      </h2>
      <p className="csw-question-subtitle">{COPY.noMatch.body}</p>
      <ActionsRow className="mt-auto">
        <span />
        <button
          className="csw-btn csw-btn-primary px-8 py-5 min-h-16 text-2xl font-normal @max-5xl:text-base @max-5xl:min-h-[42px] @max-5xl:px-[14px] @max-5xl:py-[10px]"
          type="button"
          onClick={onRestart}
        >
          {COPY.noMatch.cta}
        </button>
      </ActionsRow>
    </section>
  )
}
